/* 
  IMPORTANT

  For right now, something is up with S3 and the browser where if a requested image (with type == image/jpeg, etc)
  gets somehow cached in the browser without the CORS headers, and can't be loaded into a canvas. Once this is fixed,
  then use Carnivore to allowing pan/zoom of the image. For now just using an img because it works.
*/

import AppStoreContext from 'contexts/AppStoreContext';
import React from 'react';
import ModalStdHeader from '../ModalStdHeader';

// const containerId = 'rfi-photo-modal-container';

interface Props {
  // photo: Photo;
  url: string;
  name: string;
}

// interface State {
//   carn?: Carnivore;
//   doc?: Doc;
// }

class BasicImageModal extends React.Component<Props> {
  // state: State = {
  //   carn: undefined,
  //   doc: undefined,
  // };

  // async componentDidMount(): Promise<void> {
  //   const { photo } = this.props;
  //   const carnivore = await import('@bluebeam/carnivore');

  //   const carn: Carnivore = new carnivore.Carnivore();

  //   const doc = carn.createDocument({
  //     id: 'photo-doc',
  //     containerId,
  //     backgroundColor: [0.9, 0.9, 0.9, 1.0],
  //   });

  //   this.setState({ doc, carn });

  //   const imgCanvas = await loadImage(photo.url);

  //   const sheet = carn.createSheet({
  //     id: 'photo-sheet',
  //     width: imgCanvas.width,
  //     height: imgCanvas.height,
  //   });

  //   doc.addSheet(sheet.id);

  //   const sheetLayer = carn.createSheetLayer({
  //     id: `photo-sheet-layer`,
  //     index: 0,
  //   });

  //   sheetLayer.fillBuffer(imgCanvas);
  //   sheet.addSheetLayer(sheetLayer.id);

  //   doc.zoomFullOnSheet(sheet.id);
  // }

  // componentWillUnmount(): void {
  //   const { doc, carn } = this.state;

  //   doc?.destroy();
  //   carn?.destroy();
  // }

  context!: React.ContextType<typeof AppStoreContext>;

  // handleZoomIn = (): void => {
  //   const { doc } = this.state;

  //   doc?.zoom(1.5);
  // };

  // handleZoomOut = (): void => {
  //   const { doc } = this.state;

  //   doc?.zoom(0.5);
  // };

  static contextType = AppStoreContext;

  static modalStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      border: 'solid 0px',
    },
    content: {
      padding: '0',
      border: 'solid 0px',
      borderRadius: '8px',
    },
  };

  handleCloseClick = (): void => {
    const { clearAllModals } = this.context.actions;

    clearAllModals();
  };

  render(): React.ReactNode {
    const { url, name } = this.props;

    return (
      <div className="column h100">
        <ModalStdHeader text="Image Attachment" />
        <div className="grow-1 pt8">
          <div
            className="flex-center"
            style={{ height: 'calc(100vh - 153px)' }}
          >
            <img className="h90 w90 of-contain" src={url} alt={name} />
          </div>
        </div>
        {/* <div className="pos-r grow-1">
          <div id={containerId} className="h100" />
          <div>
            <ZoomControls
              onZoomIn={this.handleZoomIn}
              onZoomOut={this.handleZoomOut}
            />
          </div>
        </div> */}
        {/* <div className="row justify-center items-center h100 pb3">
          <img className="max-h100" alt="" src={photo.url} />
        </div> */}
        {/* <div className="hs3 shrink-0 bgd-primary row items-center justify-between px3">
          <DownloadPhoto photo={photo} />
        </div> */}
      </div>
    );
  }
}

export default BasicImageModal;
